import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardMedia, CardActionArea, Grid, Typography, Container, } from '@mui/material';
import { defaultProjects } from '../../../config/projects';
const classes = {
    heroContent: {
        padding: '32px 0px 32px',
    },
    cardGrid: {
        paddingTop: '0px',
        paddingBottom: '0px',
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
};
export const ProjectSelectionArea = ({ onProjectChosen = () => { }, }) => {
    const navigate = useNavigate();
    return (React.createElement(Grid, { container: true, spacing: 6 }, defaultProjects.map((card) => (React.createElement(Grid, { item: true, key: card.title, xs: 12, sm: 6, md: 4 },
        React.createElement(Card, { sx: Object.assign(Object.assign({}, classes.card), { opacity: card.disabled ? 0.3 : 1 }), raised: true },
            React.createElement(CardActionArea, { onClick: () => {
                    if (!card || card.disabled || !card.title)
                        return;
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                    navigate(`/search?project=${card.title}`);
                    // If provided, trigger the callback to e.g. close the popup/dialog
                    onProjectChosen === null || onProjectChosen === void 0 ? void 0 : onProjectChosen();
                } },
                React.createElement(CardMedia, { sx: classes.cardMedia, image: card.thumbnail, title: card.title }),
                React.createElement(CardContent, { sx: classes.cardContent },
                    React.createElement(Typography, { gutterBottom: true, variant: 'h5', component: 'h2' }, card.title),
                    React.createElement(Typography, null, card.description)))))))));
};
export const ProjectSelector = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: classes.heroContent },
            React.createElement(Container, { maxWidth: 'md' },
                React.createElement(Typography, { variant: 'h3', align: 'center', color: 'textPrimary', gutterBottom: true }, "Select a project"),
                React.createElement(Typography, { variant: 'h5', align: 'center', color: 'textSecondary', paragraph: true }, "You can search the Earth System Grid Federation for various kinds of climate data. Please select the project you are looking for."))),
        React.createElement(Container, { sx: classes.cardGrid, maxWidth: 'md' },
            React.createElement(ProjectSelectionArea, null))));
};
